import { CellProps } from 'react-table'
import { formatDateTime } from '../../../../../../../_metronic/helpers'
import {
  TIPO_TERMO_LABELS,
  TermoConsentimento,
  TipoTermoConsentimento,
} from '../../../core/_models'
import { TermosActionsCell } from './TermosActionsCell'
import {
  PlainHeader,
  sortableColumn,
  StackedCell,
  StatusBadge,
  TableColumn,
} from '../../../../../../components'
import { useQueryRequest } from '../../../core/QueryRequestProvider'

/** Rótulo do destinatário; termo gravado antes do campo existir é do paciente. */
const rotuloTipo = (termo: TermoConsentimento): string =>
  TIPO_TERMO_LABELS[termo.tipo ?? TipoTermoConsentimento.Paciente]

const termosColumns: ReadonlyArray<TableColumn<TermoConsentimento>> = [
  // Título com a versão e o destinatário como apoio; título e versão seguem ordenáveis.
  sortableColumn<TermoConsentimento>({
    id: 'titulo',
    useQueryRequest,
    fields: [
      { field: 'titulo', label: 'Título' },
      { field: 'versao', label: 'Versão' },
    ],
    Cell: ({ row }: CellProps<TermoConsentimento>) => (
      <StackedCell
        primary={row.original.titulo}
        secondary={`Versão ${row.original.versao} · ${rotuloTipo(row.original)}`}
      />
    ),
  }),
  // Vigência: início em destaque, fim como apoio (ou "sem data de término").
  sortableColumn<TermoConsentimento>({
    id: 'dtVigenciaInicio',
    cellWidth: '220px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [
      { field: 'dtVigenciaInicio', label: 'Início vigência' },
      { field: 'dtVigenciaFim', label: 'Fim' },
    ],
    Cell: ({ row }: CellProps<TermoConsentimento>) => (
      <StackedCell
        tabular
        primary={formatDateTime(row.original.dtVigenciaInicio)}
        secondary={
          row.original.dtVigenciaFim
            ? `até ${formatDateTime(row.original.dtVigenciaFim)}`
            : 'Sem data de término'
        }
      />
    ),
  }),
  sortableColumn<TermoConsentimento>({
    id: 'publicado',
    cellWidth: '128px',
    useQueryRequest,
    fields: [{ field: 'publicado', label: 'Situação' }],
    Cell: ({ row }: CellProps<TermoConsentimento>) => (
      <StatusBadge active={row.original.publicado} labels={['Publicado', 'Inativo']} />
    ),
  }),
  {
    Header: () => <PlainHeader>Ações</PlainHeader>,
    id: 'actions',
    cellWidth: '96px',
    align: 'end',
    Cell: ({ row }: CellProps<TermoConsentimento>) => <TermosActionsCell termo={row.original} />,
  },
]

export { termosColumns }
